import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DivisionSummaryDetailReportForRange } from './Pages'

export const DivisionSummaryDetailReportForRangeRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DivisionSummaryDetailReportForRange} />
    </Fragment>
)